







































































































import { Component, Vue } from "vue-property-decorator";
import { SurveyType, SurveyActionType, Product, SurveyStatusType } from "@/interfaces";

import { SurveyModule } from "@/store";
import { getAnalysisAttractions } from "@/services";

import { date } from "quasar";

@Component
export default class AttractivenessAnalysis extends Vue {
  @SurveyModule.bindings.Mutation
  setSurveyType!: (type: SurveyType | null) => void;

  attractivenessList: Product[] = [];

  loading = false;

  filteredData: Product[] = [];

  searchText = "";

  async mounted() {
    try {
      this.attractivenessList = await getAnalysisAttractions();
      this.setSurveyType(SurveyType.ANALYSIS_ATTRACTION);
      this.filteredData = this.attractivenessList;
    } catch (error) {
      console.log(error);
    }
  }

  dataSearchSubmit() {
    if (this.searchText.trim() !== "") {
      this.filteredData = this.attractivenessList.filter(attractiveness =>
        attractiveness.name.toLowerCase().includes(this.searchText.toLowerCase()),
      );
    } else {
      this.filteredData = this.attractivenessList;
    }
  }

  openShowAttractiveness(attractiveness: Product) {
    this.$router
      .push(
        `survey/${SurveyType.ANALYSIS_ATTRACTION}/${
          attractiveness.surveys.length > 0 ? attractiveness.surveys[0].id : attractiveness.id
        }/${attractiveness.surveys.length === 0 ? SurveyActionType.NEW : SurveyActionType.UPDATE}`,
      )
      .catch(error => console.log(error));
  }

  getAttractivenessDate(attractiveness: Product) {
    if (attractiveness.surveys.length > 0) {
      return date.formatDate(attractiveness.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  get statusLabelClass() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: SurveyStatusType) => {
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Completato";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Indefinito";
      }
    };
  }

  get columns() {
    return [
      {
        name: "name",
        label: "Nome",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: Product) => (row.surveys.length > 0 ? this.statusLabel(row.surveys[0].status) : ""),
        align: "left",
        sortable: true,
      },
      {
        label: "Ultima modifica",
        name: "date",
        field: (row: Product) =>
          row.surveys.length > 0 ? date.formatDate(row.surveys[0].updated_at, "DD/MM/YYYY HH:mm") : "",
        align: "left",
        sortable: true,
      },
      { name: "edit", align: "center" },
      { name: "complete", align: "center" },
    ];
  }
}
